import api from './api';
import store from '~/store';

import { Types } from '~/store/constants';

import notification from './notification';

import util from '~/assets/util';
import { Roles } from '~/assets/constants';
import axios from 'axios';

const service = {
  async login(email: string, password: string) {
    try {
      const res = await api.post('dashboard/login', {
        email,
        password,
        restore_cart: false,
      });

      const data = res.data;

      return this.save(data);
    } catch (err) {
      if (!axios.isAxiosError(err)) {
        notification.$e(err);
        return false;
      }

      if (err.response.status === 401) {
        notification.$e(util.t('WRONG_CREDENTIALS'));
      }

      return false;
    }
  },

  save(data: any) {
    if (data.token && data.user) {
      const user = data.user;
      const token = data.token;

      const dashboardRoles = [Roles.DASHBOARD, Roles.DASHBOARD_CATAVENTO];
      if (!dashboardRoles.includes(user.role)) {
        notification.$e(util.t('UNAUTHORIZED'));

        return false;
      }

      store.dispatch({ type: Types.USER_TOKEN_SET, token });
      store.dispatch({ type: Types.USER_SET, data: user });

      localStorage.setItem('authtoken', token);

      return data;
    }

    return false;
  },

  async getUser() {
    try {
      const res = await api.get('/auth/me');

      const data = res.data;

      return data.user;
    } catch (e) {
      console.error('user.getUser error', e);
    }
  },

  logout() {
    store.dispatch({ type: Types.USER_RESET });

    return localStorage.removeItem('authtoken');
  },
};

export default service;
